import { render, staticRenderFns } from "./cooperativedetail.vue?vue&type=template&id=038911ef&scoped=true"
import script from "./cooperativedetail.vue?vue&type=script&lang=js"
export * from "./cooperativedetail.vue?vue&type=script&lang=js"
import style0 from "./cooperativedetail.vue?vue&type=style&index=0&id=038911ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038911ef",
  null
  
)

export default component.exports